<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <div
        class="container-header"
      >
        <b-link
          to="/"
        >
          <img
            :src="require('@/assets/svg/maxlogo.png')"
            alt="Logo"
            class="logo-page"
          >
        </b-link>
        <p class="header-title">
          Partner Registration
        </p>
        <p class="header-sub">
          <!-- To start using TRIADS Platform, please fill following information: -->
        </p>
      </div>
      <!-- <span class="desc-tab-contact">
        Add contact information
      </span>
      <span class="desc-tab-company-details">
        Add company information
      </span>
      <span class="desc-tab-bank-account">
        Add bank account information
      </span> -->
      <!-- Register v1 -->
      <b-card class="mb-0">
        <form-wizard
          color="#7367F0"
          :title="null"
          :subtitle="null"
          finish-button-text="Submit"
          back-button-text="Back"
          class="steps-transparent"
          @on-complete="formSubmitted"
        >
          <wizard-step
            slot="step"
            slot-scope="props"
            :tab="props.tab"
            :transition="props.transition"
            :index="props.index"
          >
            <div
              slot="title"
              class="text-left"
            >
              <div class="font-medium-1 font-weight-bolder">
                {{ props.tab.title }}
              </div>
              <div class="text-sec font-small-3">
                {{ getSubTitle(props.index) }}
              </div>
            </div>
          </wizard-step>
          <!-- contact detail tab -->
          <tab-content
            title="Contact Details"
            icon="feather icon-user"
            :before-change="validationForm"
          >
            <validation-observer
              ref="accountRules"
              tag="form"
            >
              <b-row>
                <b-col md="6">
                  <b-form-group
                    label="First Name"
                    label-for="firstname"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="first name"
                      rules="required"
                    >
                      <b-form-input
                        id="firstname"
                        ref="firstname"
                        v-model="firstname"
                        placeholder="First Name"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Last Name"
                    label-for="lastname"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="lastname"
                      rules="required"
                    >
                      <b-form-input
                        id="lastname"
                        v-model="lastname"
                        placeholder="Last Name"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    label="Email"
                    label-for="email"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="email"
                      rules="required|email|checkingEmail"
                    >
                      <b-form-input
                        id="email"
                        v-model="regEmail"
                        type="email"
                        placeholder="john.doe@email.com"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    label="Phone Number"
                    label-for="phone"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="phone"
                      rules="required|max13|regex:^([0-9]+)$"
                    >
                      <b-form-input
                        id="phone"
                        v-model="phone"
                        type="number"
                        placeholder="62xxxxxxxx"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    label="Citizen ID"
                    label-for="citizen-id"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="citizenid"
                      rules="required|max16|regex:^([0-9]+)$"
                    >
                      <b-form-input
                        id="citizenid"
                        v-model="citizenid"
                        type="number"
                        placeholder="327xxxxxxxxxxxx"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="IOH Username"
                    label-for="username"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="username"
                      rules="required|min:4|checkingUsername"
                    >
                      <b-form-input
                        id="username"
                        v-model="username"
                        placeholder="Create IOH Username"
                        :state="errors.length > 0 ? false:null"
                        :class="{ 'is-invalid': invalidUsername }"
                        @keydown.space.prevent
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                      <small
                        v-show="invalidUsername & errors.length < 1"
                        class="text-danger"
                      >
                        {{ msgInvalidUsername }}
                      </small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="IOH Password"
                    label-for="password"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="password"
                      rules="required|min:6"
                    >
                      <b-input-group
                        class="input-group-merge password-group-icon"
                        :class="errors.length > 0 || isError ? 'is-invalid' : null"
                      >
                        <b-form-input
                          id="password"
                          v-model="password"
                          :type="passwordFieldType"
                          class="form-control-merge"
                          :state="errors.length > 0 ? false : null"
                          placeholder="Set IOH Password"
                          :class="{ 'is-invalid': isError }"
                        />

                        <b-input-group-append is-text>
                          <feather-icon
                            class="cursor-pointer"
                            :icon="passwordToggleIcon"
                            @click="togglePasswordVisibility"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </validation-observer>
            <button
              class="btn btn-md btn-primary
              btn-reset-contact"
              @click="resetContactDetails"
            >
              Reset
              <feather-icon
                icon="RotateCcwIcon"
                class="mr-50 ml-50"
              />
            </button>
          </tab-content>

          <!-- company details -->
          <tab-content
            title="Company Details"
            icon="feather icon-briefcase"
            :before-change="validationFormCompany"
          >
            <validation-observer
              ref="companyRules"
              tag="form"
            >
              <b-row>
                <b-col md="6">
                  <b-form-group
                    label-for="company-name"
                    label="Company Name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="company name"
                      rules="required"
                    >
                      <b-form-input
                        id="company-name"
                        ref="companyname"
                        v-model="companyname"
                        placeholder="Company Name"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label-for="npwp"
                    label="NPWP"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="npwp_number"
                      rules="required"
                    >
                      <b-form-input
                        id="npwp_number"
                        ref="npwp"
                        v-model="npwp"
                        placeholder="NPWP Number"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Company Business Field"
                    label-for="company-business"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="company business"
                      rules="required"
                    >
                      <v-select
                        id="company-business"
                        v-model="selectedCompanyBusiness"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="companyBusiness"
                        :reduce="text => text.value"
                        label="text"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Company Type"
                    label-for="company-type"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="company type"
                      rules="required"
                    >
                      <v-select
                        id="company-type"
                        v-model="selectedCompanyType"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="companyType"
                        :reduce="text => text.value"
                        label="text"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Company Address"
                    label-for="i-company-address"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="company address"
                      rules="required"
                    >
                      <b-form-textarea
                        id="company-address"
                        v-model="companyaddress"
                        placeholder="Company Address"
                        rows="3"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Country"
                    label-for="country"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="country"
                      rules="required"
                    >
                      <v-select
                        id="country"
                        v-model="selectedCountry"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="countryName"
                        label="text"
                        :state="errors.length > 0 ? false:null"
                        @input="setProvince"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Province"
                    label-for="province"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="province"
                      rules="required"
                    >
                      <v-select
                        id="province"
                        v-model="selectedProvice"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="provinceName"
                        label="text"
                        :state="errors.length > 0 ? false:null"
                        @input="setCity"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="City"
                    label-for="i-city"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="city"
                      rules="required"
                    >
                      <v-select
                        id="city"
                        v-model="selectedCity"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="cityName"
                        label="text"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="ZIP Code"
                    label-for="zip-code"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="zip code"
                      rules="required"
                    >
                      <b-form-input
                        id="zip-code"
                        v-model="zipcode"
                        placeholder="ZIP Code"
                        type="number"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col md="12">
                  <hr>
                  <b-alert
                    show
                    variant="success"
                    class="mb-0"
                  >
                    <div class="alert-body">
                      <div class="d-flex flex-row align-items-center">
                        <div class="mx-0 mx-md-2">
                          <feather-icon
                            icon="InfoIcon"
                            class="mr-50"
                            size="25"
                          />
                        </div>
                        <div class="ml-1 row w-100">
                          <ul class="m-0 col-md-6">
                            <li>File Format: .pdf</li>
                            <li>Maximum File Size: 2MB</li>
                          </ul>
                          <!-- </div>
                        <div> -->
                          <ul class="m-0 col-md-6">
                            <li>File Name: Alpha Numeric Only!</li>
                            <li>No Special Character Needed!</li>
                          </ul>
                        </div>
                      </div>
                      <!-- <b-row> -->
                      <!-- </b-row> -->
                    </div>
                  </b-alert>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <b-form-group
                    label="Upload SITU"
                    label-for="situ"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="upload situ"
                      rules="required|size:2000"
                    >
                      <b-form-file
                        id="situ"
                        ref="fileSitu"
                        v-model="fileSitu"
                        name="situ"
                        accept="application/pdf"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    label="Upload PKP"
                    label-for="pkp"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="upload pkp"
                      rules="required|size:2000"
                    >
                      <b-form-file
                        id="pkp"
                        ref="filePkp"
                        v-model="filePkp"
                        name="pkp"
                        accept="application/pdf"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    label="Upload TDP"
                    label-for="tdp"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="upload tdp"
                      rules="required|size:2000"
                    >
                      <b-form-file
                        id="tdp"
                        ref="fileTdp"
                        v-model="fileTdp"
                        name="tdp"
                        accept="application/pdf"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Upload NPWP"
                    label-for="npwp"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="upload npwp"
                      rules="required|size:2000"
                    >
                      <b-form-file
                        id="npwp"
                        ref="fileNpwp"
                        v-model="fileNpwp"
                        name="npwp"
                        accept="application/pdf"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Upload Akta Pendirian Perusahaan"
                    label-for="article"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="upload akta pendirian perusahaan"
                      rules="required|size:2000"
                    >
                      <b-form-file
                        id="article"
                        ref="fileArticle"
                        v-model="fileArticle"
                        name="fileArticle"
                        accept="application/pdf"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </validation-observer>
            <button
              class="btn btn-md btn-primary btn-reset-company"
              @click="resetCompany"
            >
              Reset
              <feather-icon
                icon="RotateCcwIcon"
                class="mr-50"
              />
            </button>
          </tab-content>

          <!-- address -->
          <tab-content
            title="Bank Account Details"
            icon="feather icon-credit-card"
            :before-change="validationFormBank"
          >
            <validation-observer
              ref="bankRules"
              tag="form"
            >
              <b-row>
                <b-col md="6">
                  <b-form-group
                    label="Bank Name"
                    label-for="bank-name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="bank-name"
                      rules="required"
                    >
                      <v-select
                        id="bank-name"
                        v-model="selectedBankName"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="bankName"
                        :reduce="text => text.value"
                        label="text"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Bank Branch"
                    label-for="bank-branch"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="bank-branch"
                      rules="required"
                    >
                      <b-form-input
                        id="bank-branch"
                        v-model="bankbranch"
                        placeholder="Bank Branch"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Bank Account Number"
                    label-for="i-bank-acoount-number"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="bank-account-number"
                      rules="required|regex:^([0-9]+)$"
                    >
                      <b-form-input
                        id="bank-acoount-number"
                        v-model="bankaccountnumber"
                        placeholder="Bank Account Number"
                        type="number"
                        rules="regex:^([0-9]+)$"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label="Bank Account Holder"
                    label-for="i-bank-acoount-holder"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="bank-account-holder"
                      rules="required"
                    >
                      <b-form-input
                        id="bank-acoount-holder"
                        v-model="bankaccountholder"
                        type="text"
                        placeholder="Bank Account Holder"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </validation-observer>
            <button
              class="btn btn-md btn-primary
              btn-reset-bank"
              @click="resetBank"
            >
              Reset
              <feather-icon
                icon="RotateCcwIcon"
                class="mr-50"
              />
            </button>
          </tab-content>
        </form-wizard>
      </b-card>
      <NavGeneral />
      <SuccessRegister ref="childPopup" />
      <Loading ref="loading" />
      <!-- /Register v1 -->
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent, WizardStep } from 'vue-form-wizard'
import { codeIconInfo } from '@/views/component/form-wizard/code'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import {
  required,
  email,
  max,
  // alpha_spaces,
  size,
} from 'vee-validate/dist/rules'
import { min } from '@validations'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BFormTextarea,
  BFormFile,
  BInputGroupAppend,
  BInputGroup,
  BAlert,
  BLink,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import vSelect from 'vue-select'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import NavGeneral from '@/views/component/NavGeneral.vue'
import axiosIns from '@/libs/axios'
import SuccessRegister from '@/views/component/SuccessRegister.vue'
import { mapActions } from 'vuex'
import Loading from '@/views/component/Loading.vue'

extend('required', {
  ...required,
  message: 'This field is required!',
})

extend('size', {
  ...size,
  message: 'File size can\'t be more 2MB!',
})

extend('email', {
  ...email,
  message: 'Please input valid email address!',
})

extend('max13', value => {
  if (value.length <= 15) {
    return true
  }
  return 'The {_field_} field must be max 15 char'
})

extend('max16', value => {
  if (value.length <= 16) {
    return true
  }
  return 'The {_field_} field must be max 16 char'
})

extend('max2', {
  ...max,
  message: 'Please input max 16 char',
})

extend('checkingUsername', async value => {
  if (value.length < 4) return true
  const resp = await axiosIns.post('/login/checkUsername', {
    username: value,
  }).then(response => response.data)
  if (resp.status) {
    return `Username ${value} has been used`
  }
  return true
})

extend('checkingEmail', async value => {
  if (value.length < 4) return true
  const resp = await axiosIns.post('/login/checkEmail', {
    email: value,
  }).then(response => response.data)
  if (resp.status) {
    return `Email ${value} has been used`
  }
  return true
})

export default {
  components: {
    FormWizard,
    TabContent,
    WizardStep,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BCard,
    BFormTextarea,
    BFormFile,
    SuccessRegister,
    ValidationProvider,
    ValidationObserver,
    NavGeneral,
    BInputGroupAppend,
    BInputGroup,
    Loading,
    BAlert,
    BLink,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      firstname: '',
      lastname: '',
      regEmail: '',
      phone: '',
      citizenid: '',
      username: '',
      password: '',
      status: '',
      bankbranch: '',
      bankaccountnumber: '',
      bankaccountholder: '',
      companyname: '',
      companyaddress: '',
      companyBusiness: [
        { value: 'select_value', text: 'Select Value' },
      ],
      npwp: '',
      zipcode: '',
      selectedCountry: '',
      selectedProvice: '',
      selectedCity: '',
      selectedBankName: '',
      selectedLanguage: '',
      selectedCompanyType: '',
      selectedCompanyBusiness: '',
      fileSitu: null,
      filePkp: null,
      fileTdp: null,
      fileNpwp: null,
      fileArticle: null,
      invalidUsername: false,
      msgInvalidUsername: '',
      isError: false,
      // validation rules
      required,
      email,
      min,
      // list data
      codeIconInfo,
      companyType: [
        { value: 'select_value', text: 'Select Value' },
      ],
      countryName: [
        // { value: 'select_value', text: 'Select Value' },
      ],
      provinceName: [
        // { value: 'select_value', text: 'Select Value' },
      ],
      cityName: [
        // { value: 'select_value', text: 'Select Value' },
      ],
      bankName: [
        { value: 'select_value', text: 'Select Value' },
      ],
      subtitle: [
        { text: 'Add contact information' },
        { text: 'Add company information' },
        { text: 'Add bank account information' },
      ],
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  mounted() {
    this.setCompanyType()
    this.setCountry()
    this.setBankName()
    this.setBusinessField()
    document.title = 'IOH Platform - Sign Up'
  },
  methods: {
    ...mapActions('auth', [
      'registration',
    ]),
    getSubTitle(index) {
      return this.subtitle[index].text
    },
    resetContactDetails() {
      this.firstname = ''
      this.lastname = ''
      this.regEmail = ''
      this.phone = ''
      this.citizenid = ''
      this.username = ''
      this.password = ''
      this.$refs.firstname.focus()
    },
    resetCompany() {
      this.companyname = ''
      this.selectedCompanyBusiness = ''
      this.selectedCompanyType = ''
      this.companyaddress = ''
      this.selectedCountry = ''
      this.selectedProvice = ''
      this.selectedCity = ''
      this.zipcode = ''
      this.npwp = ''
      this.$refs.fileSitu.reset()
      this.$refs.filePkp.reset()
      this.$refs.fileTdp.reset()
      this.$refs.fileNpwp.reset()
      this.$refs.fileArticle.reset()
      this.$refs.companyname.focus()
    },
    resetBank() {
      this.selectedBankName = ''
      this.bankbranch = ''
      this.bankaccountnumber = ''
      this.bankaccountholder = ''
    },
    setCompanyType() {
      this.$http.get('companyType').then(response => {
        if (response.data.status) {
          this.companyType = response.data.data.map(this.mapListSelect)
        } else {
          this.companyType = [
            { value: '', text: 'No Option' },
          ]
        }
      })
    },
    setCountry() {
      this.$http.get('country').then(response => {
        if (response.data.status) {
          this.countryName = response.data.data.map(this.mapListSelect)
        } else {
          this.countryName = [
            // { value: '', text: 'No Option' },
          ]
        }
      })
    },
    setProvince() {
      const countryId = this.selectedCountry.value
      this.$http.get(`province/${countryId}`).then(response => {
        if (response.data.status) {
          this.provinceName = response.data.data.map(this.mapListSelect)
        } else {
          this.provinceName = [
            // { value: '', text: 'No Option' },
          ]
        }
      })
    },
    setCity() {
      const provinceId = this.selectedProvice.value
      this.$http.get(`regencies/${provinceId}`).then(response => {
        if (response.data.status) {
          this.cityName = response.data.data.map(this.mapListSelect)
        } else {
          this.cityName = [
            // { value: '', text: 'No Option' },
          ]
        }
      })
    },
    setBusinessField() {
      this.$http.get('business').then(response => {
        if (response.data.status) {
          this.companyBusiness = response.data.data.map(this.mapListSelect)
        } else {
          this.companyBusiness = [
            { value: '', text: 'No Option' },
          ]
        }
      })
    },
    setBankName() {
      this.$http.get('bankName').then(response => {
        if (response.data.status) {
          this.bankName = response.data.data.map(this.mapListSelect)
        } else {
          this.bankName = [
            { value: '', text: 'No Option' },
          ]
        }
      })
    },
    mapListSelect(data) {
      return { value: data.id, text: data.name }
    },
    validationForm() {
      this.invalidUsername = false
      this.msgInvalidUsername = ''
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormCompany() {
      return new Promise((resolve, reject) => {
        this.$refs.companyRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormBank() {
      return new Promise((resolve, reject) => {
        this.$refs.bankRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    formSubmitted() {
      let formData = new FormData()
      formData.append('firstname', this.firstname)
      formData.append('lastname', this.lastname)
      formData.append('email', this.regEmail)
      formData.append('phone', this.phone)
      formData.append('citizen_id', this.citizenid)
      formData.append('username', this.username)
      formData.append('password', this.password)
      formData.append('company_name', this.companyname)
      formData.append('npwp_number', this.npwp)
      formData.append('business_field_id', this.selectedCompanyBusiness)
      formData.append('company_type', this.selectedCompanyType)
      formData.append('company_address', this.companyaddress)
      formData.append('country', this.selectedCountry.value)
      formData.append('province', this.selectedProvice.value)
      formData.append('city', this.selectedCity.value)
      formData.append('zip_code', this.zipcode)
      formData.append('bank_id', this.selectedBankName)
      formData.append('bank_branch', this.bankbranch)
      formData.append('bank_account', this.bankaccountnumber)
      formData.append('bank_account_name', this.bankaccountholder)
      formData.append('upload_situ', this.$refs.fileSitu.files[0], this.fileSitu.name)
      formData.append('upload_pkp', this.$refs.filePkp.files[0], this.filePkp.name)
      formData.append('upload_tdp', this.$refs.fileTdp.files[0], this.fileTdp.name)
      formData.append('upload_npwp', this.$refs.fileNpwp.files[0], this.fileNpwp.name)
      formData.append('upload_akta_pendirian', this.$refs.fileArticle.files[0], this.fileArticle.name)
      this.$refs.loading.show()
      this.registration(formData).then(response => {
        if (response.status) {
          this.$refs.loading.hide()
          this.$refs.childPopup.showModal()
        }
      })
      // this.accessApi.post('register',
      //   formData,
      //   {
      //     headers: { 'Content-Type': 'multipart/form-data' },
      //   })
      //   .then(response => {
      //     if (response.status) {
      //       this.$refs.childPopup.showModal()
      //     }
      //   })
    },
  },
}
</script>

<style lang="scss" scope>
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/pages/page-auth.scss';
.vue-form-wizard .wizard-nav-pills{
  flex-wrap: nowrap !important;
  flex-direction: row !important;
}
.vue-form-wizard .wizard-navigation .wizard-nav {
  padding: 0 !important;
  flex-grow: 1;
}
.vue-form-wizard .wizard-navigation .wizard-nav li {
  margin-right: 0 !important;
}
.logo-page{
  max-width: 182px;
  max-height: 58px;
  object-fit: contain;
}
.container-header{
  text-align: center;
}
.auth-inner{
  max-width: 822px !important;
  font-family: 'Rubik', sans-serif !important;
}
.header-title{
  font-weight: bold;
  font-size: 18px;
  margin: 18px 0 4px 0;
}
.header-sub{
  margin-bottom: 29px;
  font-size: 16px;
}
.wizard-tab-content{
  // -webkit-box-shadow: none;
  box-shadow: none !important;
}
.wizard-card-footer{
  box-shadow: none !important;
}
.wizard-nav-pills{
  border-bottom: 1px solid rgba(34, 41, 47, 0.08) !important;
}
.wizard-icon-container {
  background-color: #4B6AAE !important;
}
.stepTitle {
  color: #4B6AAE !important;
}
.wizard-btn{
  background-color: #4B6AAE !important;
  border-color: #4B6AAE !important;
  font-family: 'Rubik' !important;
  letter-spacing: 0.5px;
}
.navbar {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.bg-info {
  background-color: transparent !important;
}
.wizard-footer-left > span > button.wizard-btn {
  border: 1px solid #4B4B4B !important;
  color: #4B4B4B !important;
  font-weight: 600 !important;
}
.desc-tab-contact, .desc-tab-company-details, .desc-tab-bank-account {
  position: absolute;
  top: 211px;
  z-index: 1000;
  font-size: 12px;
  color: #B9B9C3;
}
.desc-tab-company-details {
  left: 306px;
}
.desc-tab-contact {
  left: 73px;
}
.desc-tab-bank-account {
  left: 550px;
}
.stepTitle {
  margin-top: -21px !important;
}
.btn-reset-contact,
.btn-reset-contact:active,
.btn-reset-company,
.btn-reset-company:active,
.btn-reset-bank,
.btn-reset-bank:active {
  position: absolute;
  bottom: 35px;
  right: 162px;
  height: 45px;
  background-color: transparent !important;
  color: #000 !important;
  border: 1px solid #4B4B4B !important;
  font-weight: bold;
}
.wizard-btn {
  width: 110px !important;
}
.btn-reset-hidden {
  visibility: hidden !important;
}
</style>
